//import React from 'react'
import {
  AttachmentsService,
  AttachmentsServiceFake,
  AttachmentsServiceImpl,
} from '../services/case-report/AttachmentsService'

export default function useAttachmentsService(): AttachmentsService {
  // Zde si nastavte na true, pokud vyvijite v ramci debug stránky
  const useFakeAttachmentsService: boolean = false

  if (useFakeAttachmentsService) {
    return new AttachmentsServiceFake()
  } else {
    return new AttachmentsServiceImpl()
  }
}
